import {
  Component,
  Input,
  forwardRef,
  ViewChild,
  OnInit,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient } from '@delon/theme';
import { NzSelectComponent, NzSelectModeType } from 'ng-zorro-antd/select';

import { SelectBaseComponent } from '../select-base';
import { SelectInstantBaseComponent } from '../selectInstant-base';

@Component({
  selector: 'app-project-select',
  templateUrl: './project-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProjectSelectComponent),
      multi: true
    }
  ]
})
export class ProjectSelectComponent
  extends SelectInstantBaseComponent
  implements OnInit, AfterViewInit {
  @ViewChild('selector') nzSelectComponent!: NzSelectComponent;

  @Input() tabindex: string | null = null;
  @Input() childOnly = true;
  @Input() mode: NzSelectModeType = 'default';

  NotShowInReport: boolean = false;

  constructor(
    http: _HttpClient,
    router: Router,
    cdr: ChangeDetectorRef,
    private resueTabService: ReuseTabService
  ) {
    super(http, cdr, router);
  }

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
  }

  ngAfterViewInit(): void {
    if (this.tabindex) {
      const nzSelectElement = this.nzSelectComponent.originElement.nativeElement;

      const searchInput = nzSelectElement.querySelector('input');

      if (searchInput) {
        searchInput.setAttribute('tabindex', this.tabindex?.toString() || '0');
      }
    }
  }

  getUrl(searchValue: string): string {
    let filter = `isActive eq true`;
    if (this.childOnly) {
      filter = `(${filter}) and hasChildren eq false`;
    }
    if (searchValue)
      return `api/projects/lookup?$top=50&$skip=0&$orderby=code asc&$filter=${filter}&keyword=${encodeURIComponent(searchValue)}`;
    else
      return `api/projects/lookup?$top=50&$skip=0&$orderby=code asc&$filter=${filter}`;
  }

  // set the location want to navigate
  jump(): string {
    return '/company/project';
  }

  // set the param
  queryParam(): String {
    return 'ProjectCode';
  }

  getProjectLabel(project: any): string {
    if (!project) return '';

    const code = project.code ?? project;
    const name = project.name ?? '';

    return name ? `${code} : ${name}` : `${code}`;
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }

}
